import axios from 'axios'
import { API_BASE, apiErrorHandler } from '../api'
import Auth from '@/services/auth'

const UPLOAD_URL = `${API_BASE}external-donations/upload-csv/`

export default class ExternalDonationsAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new ExternalDonationsAPI(cls)
  }

  uploadCSV(file, { isStaff, organization, subOrganization }) {
    let data = new FormData()
    data.append('file', file)
    if (isStaff) {
      data.append('organization', organization)
      data.append('subOrganization', subOrganization)
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const promise = axios.post(UPLOAD_URL, data, options).catch(
      apiErrorHandler({
        apiName: 'External Donation API (uploadCSV) error',
      }),
    )
    return promise
  }
}
